const instanceId = {
  HOME_ZINGA: 'home-zinga',
  HOME_FAVORITES: 'home-favorites',
};

export default instanceId;
